import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import classNames from "classnames";
import React from "react";
import { Field, FieldProps, FieldRenderProps } from "react-final-form";
import "./CheckboxFieldV2.scss";

interface ICheckboxFieldProps<T extends HTMLInputElement> extends FieldProps<any, FieldRenderProps<any, T>> {
  label?: string;
  labelInfo?: string;
  labelPosition?: "above" | "side";
  inputProps?: any;
}

export default class CheckboxField<T extends HTMLInputElement> extends React.Component<ICheckboxFieldProps<T>> {
  render() {
    const { label, labelInfo, labelPosition = "side", inputProps, ...fieldProps } = this.props;

    return (
      <Field {...fieldProps} type="checkbox">
        {({ input, meta }) => (
          <div
            className={classNames("checkbox-field-v2", this.props.className, {
              active: input.checked,
              info: !!labelInfo,
              above: labelPosition === "above",
            })}>
            {label && labelPosition === "above" && <div className="checkbox-label">{label}</div>}

            <div className="checkbox-container">
              <label className="checkbox-wrapper">
                <input {...input} {...inputProps} type="checkbox" />
                <span className="custom-checkbox" />
                {label && labelPosition === "side" && <span className="checkbox-text">{label}</span>}
              </label>
              {labelInfo && (
                <Tooltip title={labelInfo} placement="top">
                  <IconButton>
                    <sup>
                      <span className="material-icons">info</span>
                    </sup>
                  </IconButton>
                </Tooltip>
              )}
            </div>
          </div>
        )}
      </Field>
    );
  }
}

export const Checkbox = (props: any) => {
  return (
    <div className="checkbox-field-v2">
      <div className="checkbox-container">
        <div className={`checkbox-wrapper`}>
          <input type="checkbox" {...props} />
          <span className="custom-checkbox" onClick={props.onClick} />
        </div>
      </div>
    </div>
  );
};
